import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const CreateIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"create"} ref={ref}/>
});

CreateIcon.displayName = "CreateIcon";
